export default __webpack_public_path__ + "static/media/pic5.fb5c7900.jpg";